<template>
  <popper
    class="w-full h-full flex"
    trigger="click"
    :options="{
      placement: 'bottom',
      modifiers: { offset: '0, 100px'}
    }"
  >
    <progress-report-marker-popper
      :key="entry.id"
      :entry="entry"
      :item="item"
      :type="type"
      :can-edit="entry[`${type}_can_provide_feedback`] && canEdit"
      @progress:save="$emit('progress:save', $event)"
    />

    <button
      slot="reference"
      class="focus:outline-none focus:shadow-inner w-full block transition-all transition-normal relative"
      :class="{
        'hover:bg-primary-200 ': entry[`${type}_status`] === null,
        'bg-grey-600 hover:bg-grey-700 rounded': entry[`${type}_status`] === 0,
        'bg-negative-600 hover:bg-negative-700 rounded': entry[`${type}_status`] === 1,
        'bg-neutral-500 hover:bg-neutral-600 rounded': entry[`${type}_status`] === 2,
        'bg-positive-600 hover:bg-positive-700 rounded': entry[`${type}_status`] === 3
      }"
    >
      <template v-if="entry[`${type}_can_provide_feedback`] && canEdit">
        <icon
          :icon="empty ? 'add' : incomplete ? 'important' : 'check'"
          class="block mx-auto w-5 h-5"
          :class="{
            'icons-primary' : entry[`${type}_status`] === null,
            'icons-negative' : entry[`${type}_status`] === 0 || entry[`${type}_status`] === 1,
            'icons-neutral' : entry[`${type}_status`] === 2,
            'icons-positive' : entry[`${type}_status`] === 3
          }"
        />
        <span class="sr-only">Add Status</span>
      </template>
      <span
        v-if="type === 'monitor' && !canEdit"
        class="absolute text-3xs pin-t pin-r p-1 font-bold"
        :class="{
          'text-grey-900': entry[`${type}_status`] === 0,
          'text-negative-900': entry[`${type}_status`] === 1,
          'text-neutral-900': entry[`${type}_status`] === 2,
          'text-positive-900': entry[`${type}_status`] === 3
        }"
      >
        M
      </span>
      <span
        v-if="type === 'msp' && !canEdit"
        class="absolute text-3xs pin-t pin-r p-1 font-bold"
        :class="{
          'text-grey-900': entry[`${type}_status`] === 0,
          'text-negative-900': entry[`${type}_status`] === 1,
          'text-neutral-900': entry[`${type}_status`] === 2,
          'text-positive-900': entry[`${type}_status`] === 3
        }"
      >
        P
      </span>
    </button>
  </popper>
</template>

<script>
/** TODO: Overlay with fields
 * - Types: Marker, Add, Future
 * - Save Progress
 * - If red/amber, provide details
 * - Check readonly
 */
import Popper from 'vue-popperjs'
export default {
  name: 'ProgressReportMarker',
  components: {
    Popper
  },
  props: {
    canEdit: {
      type: Boolean,
      default: false
    },
    entry: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: 'partner',
      validator(value) {
        return ['msp', 'monitor', 'partner'].includes(value)
      }
    }
  },
  computed: {
    empty() {
      return this.entry[`${this.type}_status`] === null
    },
    incomplete() {
      if(!this.canEdit) return;
      if(this.entry[`${this.type}_status`] === 3) return
      if(this.entry[`${this.type}_status`] < 3 && this.entry[`${this.type}_feedback`]) return
      return true
    },
    buttonType() {
      return this.canEdit && this.entry
    }
  }
}
</script>
<style scoped>
::v-deep [x-arrow] {
  @apply text-primary-500;
  transition: color .2s ease-in-out
}
::v-deep .arrow-grey [x-arrow] {
  @apply text-grey-600;
}
::v-deep .arrow-negative [x-arrow] {
  @apply text-negative-600;
}
::v-deep .arrow-neutral [x-arrow] {
  @apply text-neutral-500;
}
::v-deep .arrow-positive [x-arrow] {
  @apply text-positive-600;
}
</style>
